// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-friendly styles for Home2 component */

.heatmap-container {
  width: 100%;
  height: inherit;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: auto;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
}
.heatmap-container > .heatmapboxtitletext {
  /*cursor: pointer;*/
  padding: 6px 2px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  color: var(--text-primary);
}
.heatmap-container > .heatmapboxtitletext > div:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
.heatmap-wrapper {
  display: flex;
  flex: 1;
  /*position: relative;*/
}

.menu-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 100dvh;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-right: 1px solid #e0e0e0;
  z-index: 1000;
  transition: transform 0.3s ease;
  overflow-y: auto;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.menu-wrapper.collapsed {
  transform: translateX(-100%);
}

.menu-header {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.menu-toggle {
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-radius: 8px;
  background: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.menu-toggle:hover {
  background: #0056b3;
}

.menu-content {
  padding: 15px;
}

.color-pickers-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.chart-wrapper {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  border: 0px;
  box-shadow: none;
  overflow: hidden;
  /*transition: margin-left 0.3s ease;*/
}

.color-range-footer-container {
  width: 70px;
  padding-left: 10px;
  padding-top: 1px;
}

.color-range-footer {
  display: flex;
  flex-direction: column; /*width: 100%;*/
}
.color-range-footer-item-container {
  width: 100%;
  display: flex;
  margin-bottom: 1px;
}
.color-range-footer-item-color {
  min-width: 20px;
  margin-right: 5px;
}
.color-range-footer-item-text {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: normal;
  color: #3c3c4380;
}

.color-range-horizontal-footer-container {
  width: 100%;
  height: 50px;
  display: none;
}

.color-range-horizontal-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-self: flex-end;
}
.color-range-horizontal-footer-item-container {
  width: 100%;
  margin-top: 5px;
}
.color-range-horizontal-footer-item-color {
  min-height: 8px;
  min-width: 33px;
  margin-right: 2px;
}
.color-range-horizontal-footer-item-text {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: normal;
  color: #3c3c4380;
}

/* Mobile styles */
@container (max-width: 767px) {
  .menu-wrapper {
    width: 280px;
  }

  .chart-wrapper {
    margin-left: 0;
  }

  .menu-wrapper.collapsed {
    transform: translateX(-100%);
  }

  .color-pickers-grid {
    grid-template-columns: 1fr;
  }

  .menu-content {
    padding: 10px;
  }

  .menu-header {
    padding: 10px;
  }
}

/* Small mobile styles */
@container (max-width: 480px) {
  .menu-wrapper {
    width: 100%;
  }

  .menu-wrapper.collapsed {
    transform: translateX(-100%);
  }

  .color-pickers-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .menu-button {
    height: 45px;
    font-size: 16px;
  }

  .menu-toggle {
    height: 45px;
    font-size: 18px;
  }
}

/* Touch-friendly improvements */
@container (hover: none) and (pointer: coarse) {
  .menu-button {
    min-height: 44px;
    padding: 12px;
  }

  .menu-toggle {
    min-height: 44px;
    padding: 12px;
  }

  .color-pickers-grid {
    gap: 12px;
  }
}

/* Landscape orientation */
@container (max-width: 767px) and (orientation: landscape) {
  .menu-wrapper {
    width: 250px;
  }

  .menu-content {
    padding: 8px;
  }

  .color-pickers-grid {
    gap: 6px;
  }

  .floating-menu-button {
    top: 10px;
    left: 10px;
    padding: 8px 16px;
    font-size: 14px;
  }
}

@container (max-width: 767px) {
  .color-range-footer-container {
    display: none;
  }
  .color-range-horizontal-footer-container {
    display: block;
  }
}

@container (max-width: 460px) {
  .color-range-horizontal-footer-item-color {
    min-width: 26px;
  }
  .color-range-horizontal-footer-item-text {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/HeatmapWidget/HeatmapWidget.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,eAAe;AACzC;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Mobile-friendly styles for Home2 component */\n\n.heatmap-container {\n  width: 100%;\n  height: inherit;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  cursor: auto;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n}\n.heatmap-container > .heatmapboxtitletext {\n  /*cursor: pointer;*/\n  padding: 6px 2px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n.heatmap-container > .heatmapboxtitletext > div:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 5px;\n}\n.heatmap-wrapper {\n  display: flex;\n  flex: 1;\n  /*position: relative;*/\n}\n\n.menu-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 300px;\n  height: 100dvh;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-right: 1px solid #e0e0e0;\n  z-index: 1000;\n  transition: transform 0.3s ease;\n  overflow-y: auto;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.menu-wrapper.collapsed {\n  transform: translateX(-100%);\n}\n\n.menu-header {\n  padding: 15px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n.menu-toggle {\n  width: 100%;\n  height: 40px;\n  font-size: 16px;\n  border-radius: 8px;\n  background: #007bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.menu-toggle:hover {\n  background: #0056b3;\n}\n\n.menu-content {\n  padding: 15px;\n}\n\n.color-pickers-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.chart-wrapper {\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  height: 100%;\n  border: 0px;\n  box-shadow: none;\n  overflow: hidden;\n  /*transition: margin-left 0.3s ease;*/\n}\n\n.color-range-footer-container {\n  width: 70px;\n  padding-left: 10px;\n  padding-top: 1px;\n}\n\n.color-range-footer {\n  display: flex;\n  flex-direction: column; /*width: 100%;*/\n}\n.color-range-footer-item-container {\n  width: 100%;\n  display: flex;\n  margin-bottom: 1px;\n}\n.color-range-footer-item-color {\n  min-width: 20px;\n  margin-right: 5px;\n}\n.color-range-footer-item-text {\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: normal;\n  color: #3c3c4380;\n}\n\n.color-range-horizontal-footer-container {\n  width: 100%;\n  height: 50px;\n  display: none;\n}\n\n.color-range-horizontal-footer {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-self: flex-end;\n}\n.color-range-horizontal-footer-item-container {\n  width: 100%;\n  margin-top: 5px;\n}\n.color-range-horizontal-footer-item-color {\n  min-height: 8px;\n  min-width: 33px;\n  margin-right: 2px;\n}\n.color-range-horizontal-footer-item-text {\n  height: 25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: normal;\n  color: #3c3c4380;\n}\n\n/* Mobile styles */\n@container (max-width: 767px) {\n  .menu-wrapper {\n    width: 280px;\n  }\n\n  .chart-wrapper {\n    margin-left: 0;\n  }\n\n  .menu-wrapper.collapsed {\n    transform: translateX(-100%);\n  }\n\n  .color-pickers-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .menu-content {\n    padding: 10px;\n  }\n\n  .menu-header {\n    padding: 10px;\n  }\n}\n\n/* Small mobile styles */\n@container (max-width: 480px) {\n  .menu-wrapper {\n    width: 100%;\n  }\n\n  .menu-wrapper.collapsed {\n    transform: translateX(-100%);\n  }\n\n  .color-pickers-grid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .menu-button {\n    height: 45px;\n    font-size: 16px;\n  }\n\n  .menu-toggle {\n    height: 45px;\n    font-size: 18px;\n  }\n}\n\n/* Touch-friendly improvements */\n@container (hover: none) and (pointer: coarse) {\n  .menu-button {\n    min-height: 44px;\n    padding: 12px;\n  }\n\n  .menu-toggle {\n    min-height: 44px;\n    padding: 12px;\n  }\n\n  .color-pickers-grid {\n    gap: 12px;\n  }\n}\n\n/* Landscape orientation */\n@container (max-width: 767px) and (orientation: landscape) {\n  .menu-wrapper {\n    width: 250px;\n  }\n\n  .menu-content {\n    padding: 8px;\n  }\n\n  .color-pickers-grid {\n    gap: 6px;\n  }\n\n  .floating-menu-button {\n    top: 10px;\n    left: 10px;\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n\n@container (max-width: 767px) {\n  .color-range-footer-container {\n    display: none;\n  }\n  .color-range-horizontal-footer-container {\n    display: block;\n  }\n}\n\n@container (max-width: 460px) {\n  .color-range-horizontal-footer-item-color {\n    min-width: 26px;\n  }\n  .color-range-horizontal-footer-item-text {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
